(async () => {
    const { 
        loadScript,
        loadStyle,
        updateURLParams,
        historyPush
    } = await import(window.theme.modules.utils);

    const baseComponent = await import(window.theme.modules.baseComponent);

    customElements.define('price-slider', class extends baseComponent.default {
        elements = {
            slider: '[data-slider]',
            min: '[data-min]',
            max: '[data-max]',
            inputMin: '[data-input-min]',
            inputMax: '[data-input-max]'
        }

        async render() {
            await this._initSlider();

            this.slider.on('change', (val) => {
                console.log(Math.round(this.slider.get()));
              const qty = document.querySelector('#product-meta-qty-input');
              if(qty)qty.value = Math.round(this.slider.get());
              const descqty = document.querySelector('#slider_qty_span');
              $('#slider_qty_span').text(Math.round(this.slider.get()));
              console.log('descqty',Math.round(this.slider.get()));
              if(descqty)descqty.text = Math.round(this.slider.get());
              this._updatePrices(Math.round(this.slider.get()));
            })
            this.slider.on('update', (val) => {
              const qty = document.querySelector('#product-meta-qty-input');
              if(qty)qty.value = Math.round(this.slider.get());
              const descqty = document.querySelector('#slider_qty_span');
              if(descqty)descqty.text = Math.round(this.slider.get());
              this._updatePrices(Math.round(this.slider.get()));
              this._validateInput(0);
            })
            this.on('resetPriceFilter', this._reset.bind(this));
            document.querySelector('#product-meta-qty-input').addEventListener('change', (e) => {
              console.log(window.product.metafields.pricestringcombined);
              let value = parseInt(e.target.value);
              /*if (value < 20) {
                value = 20;
                e.target.value = value;
              }
              if (value > 3000) {
                value = 3000;
                e.target.value = value;
              }
              this.slider.set(value);*/
              this._updatePrices(value);
              this._validateInput(0);
            });

           document.querySelector('[data-add-to-list]').addEventListener('click', async function(e) {
              e.preventDefault();
            
              const $button = $(this);
              $button.prop('disabled', true);
            
              const variantId = $('product-form form [name="id"]').val();
              const quantity = $('#product-meta-qty-input').val() || 1;
              const decID = $('#decnameselect').val();
              const decName  = $('#decnameselect option:selected').text().trim();
              const activeWL = localStorage.getItem('ActiveWL');

              // Get variant title and SKU from window.product
              const selectedVariantId = $('product-form form [name="id"]').val();
              const selectedVariant = window.product.variants.find(v => v.id == selectedVariantId);
              const variantTitle = selectedVariant ? selectedVariant.title : '';
              const variantSku   = selectedVariant ? selectedVariant.sku   : '';
            
              if (!variantId || !decID) {
                alert("Please select a variant and decoration option.");
                $button.prop('disabled', false);
                return;
              }
            
              $.ajax({
                url: 'https://app.crowdmerch.com.au/crowdmerch/homepage/addToWishlist',
                type: 'POST',
                dataType: 'json',
                data: {
                  variantId: variantId,
                  quantity: quantity,
                  decID: decID,
                  decName: decName,
                  productId: product.id,
                  productTitle: product.title, // ← NEW
                  variantTitle: variantTitle, // ← NEW
                  variantSku:   variantSku, // ← NEW (if sku is in data attr)
                  ActiveWL: activeWL
                },
                success: function(res) {
                  console.log('res ',res.status);
                  if (!res || !res.status) {
                      alert('Error: Invalid response from server');
                      return;
                  }

                  if (res.status === 'created' || res.status === 'updated') {
                    if (res.id) {
                      localStorage.setItem('ActiveWL', res.id);
                    }
                    console.log('resid',res.id);
                    
                   console.log( 'wishListmm',localStorage.getItem('wishList'));
                    //update localstorage wishlist
                    $.ajax({  
                      url: 'https://app.crowdmerch.com.au/crowdmerch/homepage/getDraftOrderItems',
                      method: 'POST',
                      data: { draftOrderId: res.id },
                      dataType: 'json',
                      success: (data) => {
                        console.log('AJAX Success Response:', data);
                        if (data && data.status === 'ok' && Array.isArray(data.items) && data.items.length > 0) {
                          console.log('wishlist count', data.items.length);
                          window.draftWishList = data.items;
                          localStorage.setItem('wishList', JSON.stringify(data.items));
                          showAddToListPopup();
                        } else {
                          console.log('No items found or status not ok', data);
                        }
                      },
                      error: function(xhr, status, error) {
                        console.error('Inner AJAX Error:', error, 'Status:', status, 'Response:', xhr.responseText);
                      },
                      complete: function() {
                        console.log('Inner AJAX Completed');
                      }
                    });
                  } else {
                    alert('Error: ' + (res.message || 'Something went wrong'));
                  }
                },
                error: function(xhr, status, error) {
                  console.error('AJAX Error Status:', xhr.status);
                  console.error('AJAX Raw Response:', xhr.responseText);
                  alert("Server error: " + xhr.responseText.substring(0, 200));
                  $button.prop('disabled', false);
                },
                complete: function() {
                  $button.prop('disabled', false);
                }
              });
            });
            function showAddToListPopup() {
              
              const popup = document.getElementById('wishlist-popup');
              const popup1 = document.getElementById('wishlist-popup1');
              //const imagesContainer = popup.querySelector('.wishlist-images');
              const itemsList = popup.querySelector('.wishlist-items');

              popup.style.display = 'none';
              popup1.style.display = 'none';

              //imagesContainer.innerHTML = '';
              itemsList.innerHTML = '';

              // Get wishlist from localStorage
              const wishListData = localStorage.getItem('wishList');

              if (!wishListData) {
                popup1.style.display = 'block';
                return;
              }

              try {
                const wishListItems = JSON.parse(wishListData);

                if (!Array.isArray(wishListItems) || wishListItems.length === 0) {
                  popup1.style.display = 'block';
                  return;
                }

                itemsList.style.maxHeight = '225px';
                itemsList.style.overflowY = 'auto';
                itemsList.style.paddingRight = '5px';

                wishListItems.forEach(item => {

                  const li = document.createElement('li');
                  li.style.display = 'flex';
                  li.style.alignItems = 'center';
                  li.style.marginBottom = '-20px';

                  // IMAGE
                  if (item.variant?.image) {
                    const img = document.createElement('img');
                    img.src = item.variant.image;
                    img.alt = item.product?.title || 'Wishlist item';
                    img.style.width = '60px';
                    img.style.margin = '10px';
                    li.appendChild(img);
                  }

                  // TITLE
                  if (item.product?.title) {
                    const title = document.createElement('span');
                    title.textContent = item.product.title;
                    li.appendChild(title);
                  }

                  itemsList.appendChild(li);

                });

                popup.style.display = 'block';
              } catch (err) {
                console.error('Error parsing wishlist data', err);
              }
            }

            document.querySelector('.open-wishlist-popup').addEventListener('click', (e) => {
              showAddToListPopup();
            });

            document.querySelector('.product-meta-qty-controls [data-dec]').addEventListener('click', (e) => {
              this._validateInput(-1);
              this.slider.set(value);
            });
            document.querySelector('.product-meta-qty-controls [data-inc]').addEventListener('click', (e) => {
              this._validateInput(1);
              const qty = document.querySelector('#product-meta-qty-input');
              this.slider.set(qty.value);
            });
          document.querySelector('#decnameselect').addEventListener('change', (e) => {
            const decorationjson = window.product.metafields.decorationjson;
            var obj = JSON.parse(decorationjson);
            console.log('objj slider',obj);
            var filteredArray = obj.Decorations.filter(function(item) {
                    return item.DecID.includes($('#decnameselect').val());
            });
         
            //get first value from undecoratedpricestring
            const pairs = obj.UndecoratedPriceString.split(',');
            const firstPair = pairs[0];      
            const [key, value] = firstPair.split(':');      
            const undecfirstQuantity = parseFloat(key);
  
            //get first value from CombinedPrcString
            const cpairs = filteredArray[0].CombinedPrcString.split(',');
            const cfirstPair = cpairs[0];      
            const [ckey, cvalue] = cfirstPair.split(':');      
            const comfirstQuantity = parseFloat(ckey);
  
            //Find MOQ
            const moq = Math.max(undecfirstQuantity, comfirstQuantity);       
            var qtyValue = document.querySelector('#product-meta-qty-input').value;
            var qtyNumber = +qtyValue; 
            const higherValue = Math.max(moq, qtyNumber);
            //this.slider.set(+higherValue);

            
             
             //Find MOQ
            // Check if the referrer is a collection page
         
          console.log('moq',moq);
            let qtybreaks = '';
            if(undecfirstQuantity > comfirstQuantity)
            {
               qtybreaks = obj.UndecoratedPriceString;
            }
            else
            {
               qtybreaks = filteredArray[0].CombinedPrcString;
            }
  console.log('qtybreaks',qtybreaks);
      
          const breaksArray = qtybreaks.split(',');
            let quantities = breaksArray.map(item => parseInt(item.split(':')[0], 10));
            let maxLimit = 1000;
            const largestQuantity = Math.max(...quantities);

            quantities = quantities.filter(q => q >= moq);

            if (!quantities.includes(moq)) {
                quantities.unshift(moq);
            }
        
            // Reconstruct qtybreaks string based on updated quantities
            qtybreaks = quantities.map(quantity => `${quantity}:Price`).join(',');
          
            // Apply the rules for the quantity breaks
            if (largestQuantity > 1000) {
                quantities = quantities.filter(q => q <= 1000);
                quantities.push(1000);
            } else if (largestQuantity < 50) {
                quantities = Array.from(new Set([...quantities, 50, 100]));
            } else if (largestQuantity < 100) {
                quantities = Array.from(new Set([...quantities, 100]));
            }
            
            
              // Set maxQuantity to 10 times the largest quantity
              const maxQuantity = Math.max(...quantities) * 10;//const range = { min: Math.min(...quantities) };
             const range = { min: moq };
            
            quantities.forEach((quantity, index) => {
              if(quantity != moq)
              {
                const percentage = ((index) / (quantities.length + 1)) * 100;
              console.log('slider qty',quantity);
                range[`${percentage}%`] = [quantity, 1];
              }
                
            });
            
            range.max = maxQuantity;
            this.slider.updateOptions({
                start: [moq],       // Update the start point with the new MOQ
                range: range,       // Update the range with the new range object
                pips: {             // You can also update pips if necessary
                    mode: 'range',
                    density: 3
                }
            });
            this.slider.set(+higherValue);
            var pipsSlider = this.$slider;
            var pips = pipsSlider.querySelectorAll('.noUi-value');
                function clickOnPip(num) {
                	console.log(pips[num])
                    var value = Number(pips[num].getAttribute('data-value'));
                    pipsSlider.noUiSlider.set(value);
                }

                for (var i = 0; i < pips.length; i++) {

                    // For this example. Do this in CSS!
                    pips[i].style.cursor = 'pointer';
                    pips[i].addEventListener('click', clickOnPip.bind(null, i));
                }
            this._updatePrices(Math.round(qtyValue));
            
            // set decID value on dropdown change
            var wishList_change = localStorage.getItem('wishList');
            console.log('megha',wishList_change);
            if(wishList_change)
            {
              var obj = JSON.parse(wishList_change);
              for (var i = 0; i < obj.length; i++) {
                var item = obj[i];
                if (item.product) {
                  item.product.decID = e.target.value; 
                }
              }
              
              var wishList = JSON.stringify(obj);
              localStorage.setItem('wishList', JSON.stringify(obj));
                console.log('wishlist-megha:',localStorage);
              
            }
            });
            this._validateInput(0);



        }


      
        _validateInput(input) {
          const qty = document.querySelector('#product-meta-qty-input')
          const value = parseInt(qty.value) + input;
          //if (value < 20 || value > 3000) {
          if (value > 3000) {
            return
          }
          if(qty) qty.value = value;
          this._updatePrices(value);
          this._updateIncermentButtons(value);
        };

        _updateIncermentButtons(value){
          if (value <= 20){
            document.querySelector('.product-meta-qty-controls [data-dec]').setAttribute( "disabled", true );
          }else{
            document.querySelector('.product-meta-qty-controls [data-dec]').removeAttribute( "disabled");
          }
          if (value >= 3000){
            document.querySelector('.product-meta-qty-controls [data-inc]').setAttribute( "disabled", true );
          }else{
            document.querySelector('.product-meta-qty-controls [data-inc]').removeAttribute( "disabled");
          }
        }

        async _initSlider() {
          console.log('start init',document.querySelector('#product-meta-qty-input').value);
            loadStyle('https://cdn.jsdelivr.net/npm/nouislider@15.4.0/dist/nouislider.min.css');
            if(!window.noUiSlider) {
                await loadScript('https://cdn.jsdelivr.net/npm/nouislider@15.4.0/dist/nouislider.min.js');
            }
        
            var referrer = document.referrer;
            var currentUrl = window.location.href;
        console.log('referrer',referrer);
          
            $('#slider_qty_span').text($('#product-meta-qty-input').val());
              //console.log('descqty',Math.round(this.slider.get()));
          
          
          console.log('window.product initslider',window.product);
          


            const decorationjson = window.product.metafields.decorationjson;
            var obj = JSON.parse(decorationjson);
          const urlParams = new URLSearchParams(window.location.search);
const qtyFromUrl = document.querySelector('#product-meta-qty-input').value;
const decorationFromUrl = urlParams.get('decoration');
   console.log('qtyFromUrl',qtyFromUrl);       
// Set decoration dropdown first
if (decorationFromUrl) {
  $('#decnameselect').val(decorationFromUrl);
}
           // console.log('objj slider',obj);
            var filteredArray = obj.Decorations.filter(function(item) {
                    return item.DecID.includes($('#decnameselect').val());
            });
           
            //get first value from undecoratedpricestring
            const pairs = obj.UndecoratedPriceString.split(',');
            const firstPair = pairs[0];      
            const [key, value] = firstPair.split(':');      
            const undecfirstQuantity = parseFloat(key);
  
            //get first value from CombinedPrcString
            const cpairs = filteredArray[0].CombinedPrcString.split(',');
            const cfirstPair = cpairs[0];      
            const [ckey, cvalue] = cfirstPair.split(':');      
            const comfirstQuantity = parseFloat(ckey);

             //Find MOQ
            // Check if the referrer is a collection page
          let moq;
let maxrange;
          let lastqty = 1;
            if (referrer.includes('/collections/') && currentUrl.includes('/products/')) {
                console.log('collectionmoq',window.product.metafields.collectiondisplayqty);
                moq = window.product.metafields.collectiondisplayqty;
            }
            else if(referrer.includes('/wish-list'))
            {
              // lastqty = parseInt(qtyFromUrl, 10); // ✅ ensure numeric

              // const undecString = window.product?.metafields?.undecoratedpricestring || '';
              // const decoration = (window.product.updateprice?.Decorations || []).find(
              //   d => d.DecID === decorationFromUrl
              // );
              // const combinedString = decoration?.CombinedPrcString || '';
            
              // const undecSteps = undecString.split(',').map(p => parseInt(p.split(':')[0])).filter(Boolean);
              // const combSteps = combinedString.split(',').map(p => parseInt(p.split(':')[0])).filter(Boolean);
              // const allSteps = [...undecSteps, ...combSteps];
            
              // if (allSteps.length > 0) {
              //   maxrange = Math.max(...allSteps);
              // }
              //moq = Math.max(undecfirstQuantity, comfirstQuantity);
              moq = qtyFromUrl;
              console.log('wish-list moq',moq);
            }
            else if (referrer.includes("/pages/rapid-search-results") ||
  referrer.includes("/search")) {
              console.log('rapid-searchmoq',window.product.metafields.collectiondisplayqty);
              moq = window.product.metafields.collectiondisplayqty;
            }else
            {
              moq = Math.max(undecfirstQuantity, comfirstQuantity);
              console.log('refrrer moq',moq);
            }
            
          console.log('moq',moq);
          moq = parseInt(moq, 10);

            let qtybreaks = '';
            if(undecfirstQuantity > comfirstQuantity)
            {
               qtybreaks = obj.UndecoratedPriceString;
            }
            else
            {
               qtybreaks = filteredArray[0].CombinedPrcString;
            }
  console.log('qtybreaks',qtybreaks);
          //set quantity breaks
          //var maxQuantity = 1000;
          //qtybreaks = obj.UndecoratedPriceString;
          const breaksArray = qtybreaks.split(',');
            let quantities = breaksArray.map(item => parseInt(item.split(':')[0], 10));
            let maxLimit = 1000;
            const largestQuantity = Math.max(...quantities);

            quantities = quantities.filter(q => q >= moq);

    if (!quantities.includes(moq)) {
        quantities.unshift(moq);
    }

    // Reconstruct qtybreaks string based on updated quantities
    qtybreaks = quantities.map(quantity => `${quantity}:Price`).join(',');
          
            // Apply the rules for the quantity breaks
            if (largestQuantity > 1000) {
                quantities = quantities.filter(q => q <= 1000);
                quantities.push(1000);
            } else if (largestQuantity < 50) {
                quantities = Array.from(new Set([...quantities, 50, 100]));
            } else if (largestQuantity < 100) {
                quantities = Array.from(new Set([...quantities, 100]));
            }
            
            //const maxQuantity = Math.min(Math.max(largestQuantity, maxLimit), largestQuantity * 10);
          //largestQuantity = Math.max(...quantities);
            const newqtybreaks = filteredArray[0].CombinedPrcString;
            const testbreaks = newqtybreaks.split(',').map(x => parseInt(x.split(':')[0]));
            const newmoq = Math.min(...testbreaks);
            console.log('testbreaks11',newmoq);
              // Set maxQuantity to 10 times the largest quantity
              const maxQuantity = Math.max(...quantities) * 10;//const range = { min: Math.min(...quantities) };
             const range = { min: newmoq };
            
            quantities.forEach((quantity, index) => {
              if(quantity != moq)
              {
                const percentage = ((index) / (quantities.length + 1)) * 100;
              console.log('slider qty',quantity);
                range[`${percentage}%`] = [quantity, 1];
              }
                
            });
            
            range.max = maxQuantity;
console.log('range',range);
          this.slider = window.noUiSlider.create(this.$slider, {
              start: [moq] ,
              connect: true,
              step: 1,
              range: range,
              pips: {
                  mode: 'range',
                  density: 3
              }
          });
          console.log('lastqty',lastqty);
          this.slider.set(+moq);
            ///var pipsSlider = document.getElementById('slider-pips');
            var pips = this.$slider.querySelectorAll('.noUi-value');

            for (var i = 0; i < pips.length; i++) {

                // For this example. Do this in CSS!
                pips[i].style.cursor = 'pointer';
                pips[i].addEventListener('click', (e) => {
                var value = Number(e.target.getAttribute('data-value'));

                this.$slider.noUiSlider.set(value);
            });
            }
          console.log('end init',document.querySelector('#product-meta-qty-input').value);
        }

        _updatePrices(quantity) {
          console.log('start update',document.querySelector('#product-meta-qty-input').value);
              //let unit_price = window.product.price_max / 100;
              const format = new Intl.NumberFormat('en-US', { style: 'decimal', maximumFractionDigits: 2, minimumFractionDigits: 2 });
              //var qtyValue = document.querySelector('#product-meta-qty-input').value;
          console.log('window.product updateprice ',window.product.metafields.decorationjson);
              const decorationjson = window.product.metafields.decorationjson;
              var obj = JSON.parse(decorationjson);          
              var filteredArray = obj.Decorations.filter(function(item) {
                  return item.DecID.includes($('#decnameselect').val());
              });
              //ssp code start
              if ('UndecoratedPriceSetup' in obj) {
                  var undecoratedpricesetupnew = parseFloat(obj.UndecoratedPriceSetup).toFixed(2);
                  //var undecvaluesnew = obj.UndecoratedPriceString.split(',').map(function(pair) {
                      //return parseFloat(pair.split(':')[1]);
                  //});
                  var undecpairsnew = obj.UndecoratedPriceString.split(',');
                  for (var i = 0; i < undecpairsnew.length; i++) {
                      var decpair = undecpairsnew[i].split(':');
                      var decminQuantity = parseInt(decpair[0]);
                      var decprice = parseFloat(decpair[1]);
              
                      if (quantity >= decminQuantity) {
                          // If it's the last pair or the next minQuantity is higher than the current quantity
                          if (i === undecpairsnew.length - 1 || quantity < parseInt(undecpairsnew[i + 1].split(':')[0])) {
                              var undecvaluesnew = decprice;
                          }
                      }
                  }
                  console.log("undecvaluesnew ",undecvaluesnew);
              }
              //ssp code end
              // Output the filtered array
          console.log('filteredArray',filteredArray);
              var obj = filteredArray[0];
              var decID = obj.DecID;
              var decName = obj.DecName;
              var combinedSetup = obj.CombinedSetup;
              var combinedPrcString = obj.CombinedPrcString;
              //console.log('combinedPrcString ',combinedPrcString);
              //ssp code start
              var pairsnew = combinedPrcString.split(',');
              for (var i = 0; i < pairsnew.length; i++) {
                  var pair = pairsnew[i].split(':');
                  var minQuantity = parseInt(pair[0]);
                  var price = parseFloat(pair[1]);
          
                  if (quantity >= minQuantity) {
                      // If it's the last pair or the next minQuantity is higher than the current quantity
                      if (i === pairsnew.length - 1 || quantity < parseInt(pairsnew[i + 1].split(':')[0])) {
                          var newprice = price;
                      }
                  }
              }

              //console.log("newprice ",newprice);
              //console.log("quantity ",quantity);
              
              let sum = Number(newprice) + Number(undecvaluesnew);

              if (isNaN(sum)) {
                sum = 0;
              }

              // Keep this UNROUNDED — round only once, after setup is amortized in.
let rawUnitPrice = sum;
let unit_price = rawUnitPrice.toFixed(2); // still fine to keep around for the NaN/zero check below

              const sliderMessage = document.querySelector("#price_slider_message");
              const nanMessage = document.querySelector("#price_nan_message");
              if (unit_price == 0) {
                sliderMessage.style.display = "block";
                nanMessage.style.display = "block";
              } else {
                sliderMessage.style.display = "none";
                nanMessage.style.display = "none";
              }
              
              //let unit_price = (newprice + undecvaluesnew).toFixed(2);
              console.log("finalPrice ",unit_price);
              //ssp code end
              // const _prices = window.product.metafields.pricestringcombined;
              // if(_prices)
              // {
              //    _prices = window.product.metafields.pricestringcombined.split(",");
              //     for (let i = 0; i < _prices.length; i++){
              //       const price_parts = _prices[i].trim().split(":");
              //       const _qty = price_parts[0] * 1.0;
              //       //console.log(_qty, quantity)
              //       unit_price = Math.max(unit_price, parseFloat(price_parts[1]));
              //     }
                  
              //     for (let i = 0; i < _prices.length; i++){
              //       const price_parts = _prices[i].trim().split(":");
              //       const _qty = price_parts[0] * 1.0;
              //       if (_qty <= quantity){
              //         unit_price = Math.min(unit_price, parseFloat(price_parts[1]));
              //       }
              //     }
    
              //     var values = window.product.metafields.pricestringcombined.split(',').map(function(pair) {
              //         return parseFloat(pair.split(':')[1]);
              //     });
              
              //     values.sort(function(a, b) {
              //         return a - b;
              //     });
              
              //     var middleValue;
              //     if (values.length > 2) {
              //         middleValue = values[Math.floor(values.length / 2)];
              //     } else if (values.length === 2) {
              //         // If there are only two values, there is no distinct middle value
              //         middleValue = values[0] === Math.min(...values) ? values[1] : values[0];
              //     } else {
              //         // If there is only one value, it is the middle value
              //         middleValue = values[0];
              //     }
              //    const pricestringcombined_price = parseFloat(middleValue * quantity).toFixed(2);
              // }
              
          //add PriceSetupCombined from metafield
             var pricesetupcombined = window.product.metafields.pricesetupcombined;
          
          // add DecorationJSON.Decorations.CombinedPrcString                
          //   const combinedPrcString_prices = obj.CombinedPrcString.split(",");                
          //   var combinedPrcString_values = combinedPrcString_prices.map(function(pair) {
          //       return parseFloat(pair.split(':')[1]);
          //   });
          //   combinedPrcString_values.sort(function(a, b) {
          //       return a - b;
          //   });
          // var combinedmiddleValue;
          //         if (combinedPrcString_values.length > 2) {
          //             combinedmiddleValue = combinedPrcString_values[Math.floor(combinedPrcString_values.length / 2)];
          //         } else if (combinedPrcString_values.length === 2) {
          //             // If there are only two values, there is no distinct middle value
          //             combinedmiddleValue = combinedPrcString_values[0] === Math.min(...combinedPrcString_values) ? combinedPrcString_values[1] : values[0];
          //         } else {
          //             // If there is only one value, it is the middle value
          //             combinedmiddleValue = combinedPrcString_values[0];
          //         }
            /*var combinedPrcString_middleValue = combinedPrcString_values.filter(function(value) {
                return value !== Math.min(...combinedPrcString_values) && value !== Math.max(...combinedPrcString_values);
            })[0];*/
            //const combinedPrcString_qty = combinedmiddleValue;
          //console.log('combinedPrcString_qty', combinedPrcString_qty);
            //const combinedPrcString_price = parseFloat(combinedPrcString_qty * quantity).toFixed(2);
            let final_price = 0;
            //calculate undecorated prices
            // var decobj = JSON.parse(decorationjson);
            // if ('UndecoratedPriceSetup' in decobj) {
            //     var undecoratedpricesetup = parseFloat(decobj.UndecoratedPriceSetup).toFixed(2);
            //     //var undecpricestring = parseFloat(decobj.UndecoratedPriceString.split(':')).toFixed(2);
            //     var undecvalues = decobj.UndecoratedPriceString.split(',').map(function(pair) {
            //         return parseFloat(pair.split(':')[1]);
            //     });
                
            //     undecvalues.sort(function(a, b) {
            //         return a - b;
            //     });
                
            //     var undecmiddleValue;
            //     if (undecvalues.length > 2) {
            //         undecmiddleValue = undecvalues[Math.floor(undecvalues.length / 2)];
            //     } else if (undecvalues.length === 2) {
            //         // If there are only two values, there is no distinct middle value
            //         undecmiddleValue = undecvalues[0] === Math.min(...undecvalues) ? undecvalues[1] : undecvalues[0];
            //     } else {
            //         // If there is only one value, it is the middle value
            //         undecmiddleValue = undecvalues[0];
            //     }
            //   const undecpricestringcombined_price = parseFloat(undecmiddleValue * quantity).toFixed(2);
            //  console.log('undecpricestringcombined_price',parseFloat(undecpricestringcombined_price));
            //   final_price = parseFloat(undecpricestringcombined_price) + parseFloat(undecoratedpricesetup) + parseFloat(combinedPrcString_price) + parseFloat(combinedSetup);
            
            // } else {
            //    final_price = parseFloat(pricestringcombined_price) + parseFloat(pricesetupcombined) + parseFloat(combinedPrcString_price) + parseFloat(combinedSetup);
            // }
            //console.log('undecpricestringcombined_price',parseFloat(undecpricestringcombined_price));
          //console.log('undecoratedpricesetup',parseFloat(undecoratedpricesetup));
          //console.log('combinedPrcString_price',parseFloat(combinedPrcString_price));
          //console.log('combinedSetup',parseFloat(combinedSetup));
          //console.log('final_price',final_price);undecoratedpricesetup
          //console.log('undecoratedpricesetup',undecoratedpricesetup);
              const brand_setup = parseFloat(undecoratedpricesetupnew) + parseFloat(combinedSetup);
          //const brand_setup_incgst = brand_setup * 0.10;
          console.log('brand_setup',brand_setup);
          console.log('up quantity',quantity);
           //console.log('brand_setup_incgst',brand_setup_incgst);
          $('#slider_qty_span').text(quantity);
              const projectSetup = document.querySelector("[data-project-setup]");
              if(projectSetup){
                var project_setup_total = parseFloat(brand_setup);
                projectSetup.innerText = format.format(project_setup_total);
                projectSetup.setAttribute("data-project-setup", project_setup_total);
              }
             const projectSetupInc = document.querySelector("[data-project-setup-inc-gst]");
              if(projectSetupInc){
                var project_setup_inc_total = parseFloat(brand_setup * 1.1);
                projectSetupInc.innerText = format.format(project_setup_inc_total);
                projectSetupInc.setAttribute("data-project-setup-inc-gst", project_setup_inc_total);
              }
              // unit_price = format.format(final_price / quantity);
              // console.log("unit_price 12 ",unit_price);
              // const unitPrice = document.querySelector("[data-unit-price]");
              // if(unitPrice){
              //   unitPrice.innerText = format.format(unit_price);
              //   unitPrice.setAttribute("data-unit-price", unit_price);
              // }
             const projectTotal = document.querySelector("[data-project-total]");
let project_total; // hoist so the later block can reuse the same rounded figure
if(projectTotal){
  // Round the FULL amortized unit price (base + setup/qty) ONCE, then multiply —
  // mirrors the backend's round($totalPerunit + setup/qty, 2) * qty exactly.
  var setupPerUnit = quantity > 0 ? (project_setup_total / quantity) : 0;
  var roundedUnitPrice = parseFloat((rawUnitPrice + setupPerUnit).toFixed(2));
  project_total = parseFloat((roundedUnitPrice * quantity).toFixed(2));

  console.log('m project_total', project_total);
  projectTotal.innerText = format.format(project_total);
  projectTotal.setAttribute("data-project-total", project_total);
}
// ← FIX: unit price display must amortize the setup cost across quantity,
// matching how project_total is derived (unit_price * qty + setup, once).
// Without this, "cost per unit" and "project total" disagree whenever setup > 0.
var setupPerUnit = quantity > 0 ? (project_setup_total / quantity) : 0;
var displayUnitPrice = parseFloat(unit_price) + setupPerUnit;

const projectTotaleach = document.querySelector("#ex-gst-each");
if(projectTotaleach){
    var project_total_each = displayUnitPrice;
    if(project_total_each == 0){
      projectTotaleach.innerText = "*see below";
    } else {
      projectTotaleach.innerText = "$" + format.format(project_total_each);
    }
}
const projectTotalInc = document.querySelector("[data-project-total-inc-gst]");
if(projectTotalInc){
    projectTotalInc.innerText = format.format(project_total * 1.1);
    projectTotalInc.setAttribute("data-project-total-inc-gst", project_total * 1.1);
   
}
const projectTotalInceach = document.querySelector("#in-gst-each");
if(projectTotalInceach){
   var project_total_each = displayUnitPrice * 1.1;
    if(project_total_each == 0){
      projectTotalInceach.innerText = "*see below";
    } else {
      projectTotalInceach.innerText = "$" + format.format(project_total_each);
    }                
}
          console.log('end update',document.querySelector('#product-meta-qty-input').value);
        }
        _reset() {
            this.slider.set(+this.getAttribute('min'));
            this._setDefault(this.$min);
            this._setDefault(this.$max);
        }
        _setDefault(el) {
            el.innerText = el.dataset.defaultValue;
        }

    })

})();
